"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCategorieByTypeQuery = exports.useDeletecategorieMutation = exports.useCategorieByIdQuery = exports.useGetCategoriesQuery = exports.useAddOrUpdateCategorieMutation = exports.CategorieApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.CategorieApi = (0, react_1.createApi)({
    reducerPath: "categorieApi",
    tagTypes: ["categorie", "categorieList", "categorieById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateCategorie: builder.mutation({
            invalidatesTags: ["categorie", "categorieList", "categorieById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `categories/${id}/`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `categories/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getCategories: builder.query({
            providesTags: ["categorieList"],
            query: (query) => (0, Utils_1.QueryUrl)("categories", query),
        }),
        categorieById: builder.query({
            query: (id) => `categories/${id}/`,
            providesTags: ["categorieById"],
        }),
        categorieByType: builder.query({
            query: (type) => `user-category-by-type/${type}/`,
            providesTags: ["categorieById"],
        }),
        deletecategorie: builder.mutation({
            query: (id) => ({
                url: `categories/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["categorie", "categorieList", "categorieById"],
        }),
    }),
});
exports.useAddOrUpdateCategorieMutation = exports.CategorieApi.useAddOrUpdateCategorieMutation, exports.useGetCategoriesQuery = exports.CategorieApi.useGetCategoriesQuery, exports.useCategorieByIdQuery = exports.CategorieApi.useCategorieByIdQuery, exports.useDeletecategorieMutation = exports.CategorieApi.useDeletecategorieMutation, exports.useCategorieByTypeQuery = exports.CategorieApi.useCategorieByTypeQuery;
